import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle, Play, Mail } from 'lucide-react';

const Step11ThankYou: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-blue-50 flex flex-col justify-center items-center px-6">
      <motion.div
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.8 }}
        className="text-center max-w-md"
      >
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ duration: 0.5, delay: 0.3 }}
          className="w-24 h-24 mx-auto mb-6 bg-green-500 rounded-full flex items-center justify-center"
        >
          <CheckCircle className="w-12 h-12 text-white" />
        </motion.div>

        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.5 }}
          className="text-3xl font-bold text-gray-900 mb-4"
        >
          Lights, Camera, AI!<br />
          <span className="text-green-600">Your Course Access Awaits!</span>
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.7 }}
          className="text-lg text-gray-600 mb-8 leading-relaxed"
        >
          Thank you for enrolling in the iSelect Digital AI Video Creation Masterclass. Check your email for instant access to your course materials and personalized blueprint. Get ready to revolutionize your video content!
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.9 }}
          className="space-y-4"
        >
          <button className="w-full bg-gradient-to-r from-gray-800 to-black text-white py-4 px-6 rounded-xl font-semibold text-lg shadow-lg hover:shadow-xl transition-all duration-300 flex items-center justify-center gap-2">
            <Play className="w-5 h-5" />
            Access My Course Now
          </button>
          
          <div className="flex items-center justify-center gap-2 text-gray-500">
            <Mail className="w-4 h-4" />
            <span className="text-sm">Check your email for course access</span>
          </div>
        </motion.div>
      </motion.div>
    </div>
  );
};

export default Step11ThankYou;